import React from 'react';
import PropTypes from 'prop-types';
import {
  withGoogleMap,
  withScriptjs,
  GoogleMap,
  Marker,
  InfoWindow
} from 'react-google-maps';
import styled from 'styled-components';

import ResultPane from './ResultPane';

import { customMarker, stylers } from './mapStyles';

const Wrapper = styled.div`
  height: 500px;
`;

const CustomMap = withScriptjs(
  withGoogleMap(({ markers, onMarkerClick, onMapLoad }) => {
    const children = markers.map((m, i) => (
      <Marker
        key={i}
        icon={customMarker}
        position={m.location}
        onClick={() => onMarkerClick(m)}
      >
        {m.show && (
          <InfoWindow>
            <ResultPane rep={m} />
          </InfoWindow>
        )}
      </Marker>
    ));

    return (
      <Wrapper>
        <GoogleMap
          ref={onMapLoad}
          defaultZoom={3}
          defaultCenter={{ lat: 37.0902, lng: -95.7129 }}
          options={{
            styles: stylers,
            disableDefaultUI: true,
            maxZoom: 15
          }}
        >
          {children}
        </GoogleMap>
      </Wrapper>
    );
  })
);

CustomMap.propTypes = {
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      location: PropTypes.shape({
        lat: PropTypes.number,
        lng: PropTypes.number
      })
    })
  )
};

export default CustomMap;
